import FooterImagesSlider from "./common/FooterImagesSlider"
import SeparatorLine from "./common/SeparatorLine"
import { useMediaQuery } from "react-responsive"
import { useLocation } from "react-router-dom"
import FooterForm from "./common/FooterForm"
import BlueFooter from "./common/BlueFooter"
import FooterUs from "./common/FooterUs"
import "./Footer.css"


const Footer = () => {

    const images = Array.from({ length: 14 }, (_, i) => i) // De 0 a 13
    const isMobile = useMediaQuery({ maxWidth: 1280 })
    const location = useLocation()

    return (

        <section className="w100">

            <SeparatorLine />
            <FooterImagesSlider images={images} />
            <SeparatorLine />

            <section className={isMobile ? "flex col gap-20 footer-section-mobile" : "flex gap-20 footer-section"}>
                <FooterUs isMobile={isMobile} />

                {
                    isMobile ? <hr className="separator-line-mobile" /> : <></>
                }

                {
                    (location.pathname?.includes("/contacto")) ? <></> : <FooterForm isMobile={isMobile} />
                }

            </section>

            <BlueFooter isMobile={isMobile} />

        </section>
    )
}

export default Footer